import React, { Component, Fragment } from 'react';
import './banners.scss';

export default  class Banners extends Component {
  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}
